import strings from '../../../Localization/Localization';

let name = {
  fieldKey: "name",
  type: "text",
  label: strings.form.alphalinkMobileProduct.name.label,
  showOnDisabled: () => false,
  validators: []
}

export const form = {
  formKey: "alphalinkMobileProductSearch",
  fields: [
    name
  ]
}
